// Category mapping configuration
// Maps category names/IDs to their icons and display names

export const categoryMapping = {
  // Salon Services
  Utensils: {
    name: "Utensil",
    icon: "/images/new/Utensils.svg",
    displayName: "Utensil Cleaning",
  },
  "Window Cleaning": {
    name: "Window Cleaning",
    icon: "/images/new/window.svg",
    displayName: "Window Cleaning",
  },
  Bathroom: {
    name: "Bathroom",
    icon: "/images/new/Bathroom.svg",
    displayName: "Bathroom Cleaning",
  },
  Dusting: {
    name: "Dusting",
    icon: "/images/new/Dusting.svg",
    displayName: "Dusting",
  },
  Kitchen: {
    name: "Kitchen",
    icon: "/images/new/kitchen.svg",
    displayName: "Kitchen Cleaning",
  },
  Balcony: {
    name: "Balcony",
    icon: "/images/new/Balcony.svg",
    displayName: "Balcony Cleaning",
  },
  Staircase: {
    name: "Staircase",
    icon: "/images/new/Staris.svg",
    displayName: "Staircase Cleaning",
  },
  Sweeping: {
    name: "Sweeping",
    icon: "/images/new/sweeping.svg",
    displayName: "Sweeping",
  },
  "Sweeping and Mopping": {
    name: "Sweeping and Mopping",
    icon: "/images/new/SweepingandMopping.svg",
    displayName: "Sweeping and Mopping",
  },
  "Fan Cleaning": {
    name: "Fan Cleaning",
    icon: "/images/new/Fan.svg",
    displayName: "Fan Cleaning",
  },
  "Water Tank Cleaning": {
    name: "Water Tank Cleaning",
    icon: "/images/new/water.svg",
    displayName: "Water Tank Cleaning",
  },
  "Kitchen Prep": {
    name: "Kitchen Prep",
    icon: "/images/new/Kitchenprep.svg",
    displayName: "Kitchen Prep",
  },
  "Fridge Cleaning": {
    name: "Fridge Cleaning",
    icon: "/images/new/Fridge.svg",
    displayName: "Fridge Cleaning",
  },
  "Roof Top Cleaning": {
    name: "Roof Top Cleaning",
    icon: "/images/new/RoofTop.svg",
    displayName: "Roof Top Cleaning",
  },
};

export const categoryDeepCleaningMapping = {
  "Bathroom Deep Cleaning": {
    name: "Bathroom Deep Cleaning",
    icon: "/images/DeepBanner/BathroomDeepCleaning.svg",
    displayName: "Bathroom Deep Cleaning",
  },
  "Kitchen Deep Cleaning": {
    name: "Kitchen Deep Cleaning",
    icon: "/images/DeepBanner/KitchenDeepCleaning.svg",
    displayName: "Kitchen Deep Cleaning",
  },
  "Bedroom Deep Cleaning": {
    name: "Bedroom Deep Cleaning",
    icon: "/images/DeepBanner/BedroomDeepCleaning.svg",
    displayName: "Bedroom Deep Cleaning",
  },
  "Dinning room Deep Cleaning": {
    name: "Dinning room Deep Cleaning",
    icon: "/images/DeepBanner/DinningRoomDeepCleaning.svg",
    displayName: "Dinning room Deep Cleaning",
  },
  "Almirah Deep Cleaning": {
    name: "Almirah Deep Cleaning",
    icon: "/images/DeepBanner/AlmirahDeepCleaning.svg",
    displayName: "Almirah Deep Cleaning",
  },
  "Cabinets Deep Cleaning": {
    name: "Cabinets Deep Cleaning",
    icon: "/images/DeepBanner/CabinetDeepCleaning.svg",
    displayName: "Cabinets Deep Cleaning",
  },
  "Balcony Deep Cleaning": {
    name: "Balcony Deep Cleaning",
    icon: "/images/DeepBanner/BalconyDeepCleaning.svg",
    displayName: "Balcony Deep Cleaning",
  },
  "Rooftop Deep Cleaning": {
    name: "Rooftop Deep Cleaning",
    icon: "/images/DeepBanner/RooftopDeepCleaning.svg",
    displayName: "Rooftop Deep Cleaning",
  },
  "Front Yard Deep Cleaning": {
    name: "Front Yard Deep Cleaning",
    icon: "/images/DeepBanner/FrontYardDeepCleaning.svg",
    displayName: "Front Yard Deep Cleaning",
  },
  "Backyard Deep Cleaning": {
    name: "Backyard Deep Cleaning",
    icon: "/images/DeepBanner/BackyardDeepCleaning.svg",
    displayName: "Backyard Deep Cleaning",
  },
  "Chimney Deep Cleaning": {
    name: "Chimney Deep Cleaning",
    icon: "/images/DeepBanner/ChimneyDeepCleaning.svg",
    displayName: "Chimney Deep Cleaning",
  },
  "Living room Deep Cleaning": {
    name: "Living room Deep Cleaning",
    icon: "/images/DeepBanner/Livingroomdeepcleaning.svg",
    displayName: "Living room Deep Cleaning",
  },
};

// Helper function to get category info by name
export const getCategoryInfo = (categoryName, normalCleaning = true) => {
  if (normalCleaning) {
    return (
      categoryMapping[categoryName] || {
        name: categoryName,
        icon: "/images/DeepBanner/CabinetDeepCleaning.svg", // fallback icon instead of empty string
        displayName: categoryName,
        description: "Service category",
        color: "#6B7280",
      }
    );
  } else {
    return (
      categoryDeepCleaningMapping[categoryName] || {
        name: categoryName,
        icon: "/images/DeepBanner/CabinetDeepCleaning.svg",
        displayName: categoryName,
        description: "Service category",
        color: "#6B7280",
      }
    );
  }
};

// Helper function to get category info by ID (if you have category IDs)
export const getCategoryInfoById = (categoryId) => {
  // You can extend this to map IDs to names if needed
  return getCategoryInfo(categoryId);
};

// Get all category names
export const getAllCategoryNames = () => {
  return Object.keys(categoryMapping);
};

// Get all category info objects
export const getAllCategories = () => {
  return Object.values(categoryMapping);
};

// Check if a category exists
export const categoryExists = (categoryName) => {
  return categoryName in categoryMapping;
};
// Get all icon URLs (both normal and deep cleaning)
export const getAllCategoryIcons = () => {
  const normalIcons = Object.values(categoryMapping)
    .map((c) => c.icon)
    .filter(Boolean);

  const deepIcons = Object.values(categoryDeepCleaningMapping)
    .map((c) => c.icon)
    .filter(Boolean);

  return [...normalIcons, ...deepIcons];
};
